// extracted by mini-css-extract-plugin
module.exports = {"bg":"tulips_bg___JDH4","container":"tulips_container__hRH6b","paperWrap":"tulips_paperWrap__Uy1mg","paper":"tulips_paper__PmWkj","paperWrapRight":"tulips_paperWrapRight__HmAD9"};